import React, { createContext, useContext, useEffect, useState } from "react";
import api from "./api";
import { applyTheme, applyFont } from "./theme";
import { initGoogleAds } from "./googleAds";

const SettingsCtx = createContext(null);

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const res = await api.get("/site");
      setSettings(res.data);
      applyTheme(res.data.theme || "classic");
      applyFont(res.data.font || "editorial");
      if (res.data.google_ads_enabled && res.data.google_ads_id) {
        initGoogleAds(res.data.google_ads_id);
      }
    } catch (e) {
      console.error("Failed to load site settings", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const refresh = () => load();

  return (
    <SettingsCtx.Provider value={{ settings, loading, refresh, setSettings }}>
      {children}
    </SettingsCtx.Provider>
  );
};

export const useSettings = () => {
  const ctx = useContext(SettingsCtx);
  if (!ctx) throw new Error("useSettings outside provider");
  return ctx;
};

// Resolve image URL: if starts with /api/uploads, prefix with backend origin
export const resolveImage = (url) => {
  if (!url) return url;
  if (url.startsWith("/api/")) {
    const base = process.env.REACT_APP_BACKEND_URL || "";
    return `${base}${url}`;
  }
  return url;
};

// Extract a YouTube video ID from watch, youtu.be, embed, or shorts URLs.
export const getYouTubeId = (url) => {
  if (!url) return null;
  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtube\.com\/embed\/|youtube\.com\/shorts\/|youtu\.be\/)([a-zA-Z0-9_-]{11})/,
  ];
  for (const re of patterns) {
    const m = url.match(re);
    if (m) return m[1];
  }
  return null;
};
